import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPin2Line = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.86709 2C7.87179 2 7.02795 2.73186 6.88719 3.71716L6.37216 7.32236C6.15823 8.81991 5.57027 10.2394 4.66262 11.4496L3.34358 13.2083C2.90091 13.7985 3.07848 14.733 3.87226 15.0284C4.61782 15.3059 6.71046 15.9081 10.9998 15.9906C10.9998 15.9937 10.9998 15.9969 10.9998 16V22C10.9998 22.5523 11.4475 23 11.9998 23C12.552 23 12.9998 22.5523 12.9998 22V16C12.9998 15.9969 12.9997 15.9937 12.9997 15.9906C17.2891 15.9081 19.3817 15.3059 20.1273 15.0284C20.9211 14.733 21.0986 13.7985 20.656 13.2083L19.3369 11.4496C18.4293 10.2394 17.8413 8.81991 17.6274 7.32237L17.1124 3.71716C16.9716 2.73186 16.1278 2 15.1325 2H8.86709ZM8.86709 4H15.1325L15.6475 7.60521C15.909 9.43554 16.6276 11.1704 17.7369 12.6496L18.3436 13.4584C17.2091 13.7095 15.2038 14 11.9998 14C8.79571 14 6.79046 13.7095 5.65598 13.4584L6.26262 12.6496C7.37197 11.1704 8.09059 9.43554 8.35206 7.60521L8.86709 4Z"
	})
});
export default SvgPin2Line;
